<template>
  <mdb-modal :show="show" @close="close()">
    <mdb-modal-header class="aqua-gradient">
      <mdb-modal-title>Select Property</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body class="overflow-hidden d-flex">
      <mdb-container>
        <mdb-row class="h-100">
          <mdb-col col="6" class="h-100">
            <bridge8-select-list
              class="ml-2 mr-2 h-100"
              entity="label"
              :options="labels"
              label="Node Label"
              :search="true"
              @selected="label = $event"
            />
          </mdb-col>
          <mdb-col col="6" class="h-100">
            <bridge8-select-list
              class="ml-2 mr-2 h-100"
              :options="props"
              entity="prop"
              label="Property Name"
              :search="true"
              :value="prop"
              @selected="prop = $event"
            />
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </mdb-modal-body>
    <mdb-modal-footer>
      <mdb-btn
        :disabled="!prop"
        rounded
        size="sm"
        gradient="aqua"
        @click.native="close(label, prop)"
        title="Select property name"
      >Select</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn
} from 'mdbvue'
import Bridge8SelectList from './Bridge8SelectList'
import {formatDT, errorCatch} from '../utils'
import {mapActions} from 'vuex'

export default {
  name: 'AdminSelectPropModal',
  data () {
    return {
      labels: [],
      label: null,
      props: [],
      prop: null,
      show: false,
      callback: (label, prop) => { console.log(`Label/prop selected: ${label}/${prop}`) }
    }
  },
  methods: {
    ...mapActions(['apiGetLabels', 'apiGetProps']),
    formatDateTime (dtObj) {
      return formatDT(dtObj)
    },
    close (label = null, prop = null) {
      this.show = false
      if (label && typeof label === 'string' && prop && typeof prop === 'string') {
        this.callback(label, prop)
      }
      this.label = null
      this.props = []
      this.prop = null
      this.callback = (label, prop) => { console.log(`Label/prop selected: ${label}/${prop}`) }
    }
  },
  mounted () {
    this.$bus.$on('admin-modal-select-prop', callback => {
      this.callback = callback
      this.show = true
    })
    this.apiGetLabels().then(labels => { this.labels = labels })
      .catch(errorCatch('Get Labels failed in Select Prop Modal', this))
  },
  beforeDestroy () {
    this.$bus.$off('admin-modal-select-prop')
  },
  watch: {
    label (newVal, oldVal) {
      if (newVal === null) {
        this.props = []
        return
      }
      if (newVal !== oldVal) {
        this.apiGetProps(newVal).then(props => { this.props = props })
          .catch(errorCatch('Get Props failed in Select Prop Modal', this))
      }
    }
  },
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    Bridge8SelectList
  }
}
</script>

<style lang="sass">
.modal-body
  max-height: 50vh
</style>



// WEBPACK FOOTER //
// src/components/AdminSelectPropModal.vue